import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCartData } from '../../../hooks/order';

// Order submission (and the payment save before it) reports failures only through redux's
// errorMessage - the legacy Terms step rendered it under its Place Order, and that step isn't
// part of the single-page checkout. Same copy as there. Rendered by each payment form just
// above its Place Order button.
const OrderErrorMessage = () => {
  const { t } = useTranslation();
  const { errorMessage } = useCartData();

  if (!errorMessage) {
    return null;
  }
  return (
    <div className="red-color spc-order-error" role="alert">
      {t('checkout.tcError')}
    </div>
  );
};

export default OrderErrorMessage;
